<template>
  <el-dialog custom-class="max-dialog" :title="title" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false">
    <el-form :model="form" ref="form1" :rules="rules">
      <!--<el-row>-->
      <!--<el-col :span="24"><div style="background-color:#E6A23C;line-height: 40px;">111</div></el-col>-->
      <!--</el-row>-->
      <div hidden>
        <el-row>
          <el-col :span="24">
            <el-form-item label="父类的编码" :label-width="formLabelWidth" prop="parentdserial">
              <el-input v-model="form.parentdserial" auto-complete="off" :required="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="10">
          <el-form-item label="分类名称" :label-width="formLabelWidth" prop="categoryname">
            <el-input v-model="form.categoryname" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生成厂商" :label-width="formLabelWidth" prop="productioncompany">
            <el-input v-model="form.productioncompany" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="6">-->
          <!--<el-form-item label="分类编码" :label-width="formLabelWidth" prop="categorycode">-->
            <!--<el-input v-model="form.categorycode" auto-complete="off" :required="true" :disabled="true"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="8">
          <el-form-item label="二维码地址" :label-width="formLabelWidth" prop="categorycode">
            <el-input v-model="form.qrcodeurl" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="排序" :label-width="formLabelWidth" prop="sortnum">
            <el-input-number v-model="form.sortnum" auto-complete="off" :required="true"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否启用" :label-width="formLabelWidth" prop="enabled">
            <el-radio-group v-model="form.enabled">
              <el-radio :label="0">禁用</el-radio>
              <el-radio :label="1">启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="" :label-width="formLabelWidth" prop="webshow">
            <el-checkbox v-model="webshow">客户下单隐藏</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ifuseaccount==0">
        <el-col :span="10">
          <el-form-item label="页面打开地址" :label-width="formLabelWidth" prop="openurl">
            <el-input v-model="form.openurl" auto-complete="off" style="width: 300px"></el-input>
            <el-button type="warning" size="mini" v-on:click="form.openurl=defaultURL">镜架地址</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="parames.length>0">
          <el-form-item label="账套" :label-width="formLabelWidth" prop="setofbooks">
            <el-radio-group v-model="form.setofbooks" v-for="(item) in parames" :key="item.value">
              <el-radio :label="item.value" :key="item.value" style="padding-right: 25px">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="标签" :label-width="formLabelWidth" prop="types">
            <el-select v-model="form.types" placeholder="请选择" style="width: 180px" filterable >
              <el-option label="" value=""></el-option>
              <el-option v-for="item in optionTypes"  :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
      <el-col :span="12">
      <el-form-item label="商标图" :label-width="formLabelWidth" prop="trademark">
      <CommonUpload ref="refshangbiao" :allowOpen="true" :fixedFileName="'trademark.jpg'" :multiple="false"
      :groupGuid="form.trademark"
      groupType="trademark" :listType="'picture-card'" :limit="10" :fileType="'img'"
      :imgMaxSize="250"
      :accept="'.png,.jpg,.jpeg'"></CommonUpload>
      </el-form-item>
      </el-col>
      <el-col :span="12">
      <el-form-item label="广告图" :label-width="formLabelWidth" prop="trademark">
      <CommonUpload ref="refguanggao" :allowOpen="true" :fixedFileName="'advertisement.jpg'"
      :groupGuid="form.trademark"
      groupType="advertisement" :listType="'picture-card'" :limit="10" :fileType="'img'"
      :imgMaxSize="900"
      :accept="'.png,.jpg,.jpeg'"></CommonUpload>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row style="float: right;z-index: 999">
        <el-col :span="24">
          <el-button type="warning" size="mini" v-on:click="query=JSON.parse(defaultqueryprop)">初始镜片参数
          </el-button>
          <el-button type="warning" size="mini" v-on:click="queryimport()">导入
          </el-button>
          <input type="file" ref="fileupload1" style="display: none;" @change="querychange($event)"/>
          <a href="./static/file/查询条件导入.xlsx">下载模板</a>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="查询条件" :label-width="formLabelWidth" prop="queryproperty">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="width:100px;background-color: #F4F4F4;  " class="center">查询名称</td>
                <td style="background-color: #F4F4F4;  text-align: center;">查询内容</td>
                <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">查询方式</td>
                <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
              </tr>
              <tr v-for="(item,index) in query">
                <td class="content">
                  <el-input v-model="item.name"></el-input>
                </td>
                <td class="content">
                  <el-input v-model="item.item"></el-input>
                </td>
                <td class="content">
                  <el-select v-model="item.edittype" placeholder="请选择">
                    <el-option v-for="item2 in types"
                               :key="item2.value"
                               :label="item2.label"
                               :value="item2.label">
                      <span style="float: left">{{ item2.label }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item2.value }}</span>
                    </el-option>
                  </el-select>
                </td>
                <td class="center content">
                  <el-button @click="deletequery(index, item)" type="text"
                             size="small">删除
                  </el-button>
                  <el-button @click="handlequery(index)" type="text"
                             size="small">新增
                  </el-button>
                </td>
              </tr>
            </table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="float: right;z-index: 999">
        <el-col :span="24">
          <el-button type="warning" size="mini" v-on:click="formp=JSON.parse(defaultformprop)">初始镜片参数</el-button>
          <el-button type="warning" size="mini" v-on:click="formpimport()">导入</el-button>
          <input type="file" ref="fileupload2" style="display: none;" @change="formpchange($event)"/>
          <a href="./static/file/表单属性导入.xlsx">下载模板</a>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="表单属性" :label-width="formLabelWidth">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="width:100px;background-color: #F4F4F4;  " class="center">属性名称</td>
                <td style="background-color: #F4F4F4;  text-align: center;">属性内容</td>
                <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">属性方式</td>
                <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">是否公有</td>
                <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
              </tr>
              <tr v-for="(item,index) in formp">
                <td class="content">
                  <el-input v-model="item.name"></el-input>
                </td>
                <td class="content">
                  <el-input v-model="item.item"></el-input>
                </td>
                <td class="content">
                  <el-select v-model="item.edittype" placeholder="请选择">
                    <el-option v-for="item2 in types"
                               :key="item2.value"
                               :label="item2.label"
                               :value="item2.value">
                    </el-option>
                  </el-select>
                </td>
                <td class="center content">
                  <el-select v-model="item.ispublic" placeholder="请选择">
                    <el-option v-for="item2 in isp"
                               :key="item2.value"
                               :label="item2.label"
                               :value="item2.value">
                    </el-option>
                  </el-select>
                </td>
                <td class="center content">
                  <el-button @click="deleteformp(index, item)" type="text"
                             size="small">删除
                  </el-button>
                  <el-button @click="handleformp(index)" type="text"
                             size="small">新增
                  </el-button>
                </td>
              </tr>
            </table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {saveData, getDetail} from '@/api/set/jxcgoodscategory';
  import {attUUID} from '@/api/attachment';

  export default {
    name: "DataContactEdit",
    data() {
      let query = [{"name": "", "item": "", "edittype": ""}]
      return {
        defaultURL:'/H5/html/shouYe/shaiXuan/jinJia_main1.html',
        dialogFormVisible: false,
        shangbiaovisible: true,
        ifuseaccount: 0,
        query1: query,
        query: [{"name": ""}],
        formp: [{"name": ""}],
        title: '',
        optionTypes:['偏光','全焦','内非','单光','双光','双非','变色/光敏感','外渐进','学生内渐进','成人内渐进','成人渐进','抗疲劳','数码染色','普通染色','炫彩','防蓝光','青少年','青少年防控','驾驶','黑牌渐进','配件','其它'],
        defaultqueryprop: '[{"name":"是否定制","item":"现片;定制片","edittype":"单选"},{"name":"折射率","item":"1.56;1.591;1.60;1.67","edittype":"单选"}]',
        defaultformprop: '[{"name":"框型","edittype":"10","ispublic":"1","item":"全框;半框;无框"},{"name":"瞳距","edittype":"30","ispublic":"1"},{"name":"瞳高","edittype":"30","ispublic":"1"},{"name":"镜宽","edittype":"30","ispublic":"1"},{"name":"梁宽","edittype":"30","ispublic":"1"},{"name":"镜高","edittype":"30","ispublic":"1"},{"name":"最大对角长","edittype":"30","ispublic":"1"}]',
        parames: [],
        form: {  //表单数据
          categorycode: '',
          parentdserial: '',
          categoryname: '',
          enabled: 1,
          qrcodeurl:'',
          sortnum: '',
          queryproperty: '',
          formproperty: '',
          trademark: '',
          openurl: "",
          advertisement: '',
          productioncompany:'',
          tenantid: '',
          filltemplate: '',
          setofbooks: '',
          types: '',
          webshow: 1,
        },
        webshow:true,
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          categoryname: [
            {required: true, message: '请输入货品分类名称', trigger: 'blur'},
          ],
        },

        types: [{
          label: '单选', value: '10'
        }, {
          label: '多选', value: '20'
        }, {
          label: '填空', value: '30'
        }, {
          label: '页面选择', value: '40'
        }
        ],
        isp: [{
          label: '是', value: '1'
        }, {
          label: '否', value: '0'
        }
        ]
      }
    },
//接受父页面传过来的值
    props: ["guid"],
    methods: {
      show() {
        this.dialogFormVisible = true;
      },
      saveData() {
        if (this.parames.length > 0 && !this.form.setofbooks) {
          this.$message.error('账套必须选择！');
          return
        }
        this.form.queryproperty = JSON.stringify(this.query);
        this.form.formproperty = JSON.stringify(this.formp);
        this.form.webshow=this.webshow?-1:1;
        this.$refs.form1.validate((valid) => {
          if (valid) {
            saveData(this.form).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;

                //刷新列表
                this.$emit('bindGrid');
              } else {
                this.$message.error(response.data.msg);
              }
            });
          }
        })
      },

      initData(categorycode) {
        this.initForm();
        getDetail({categorycode: categorycode}).then(response => {
          for (let i in this.form) {
            this.form[i] = response.data.obj[i];
          }
          if (!this.form.trademark) {
            this.form.trademark = attUUID();
          }
          this.webshow=this.form.webshow==-1;

          if (response.data.obj.queryproperty != 'null' || response.data.obj.queryproperty != '') {
            this.query = JSON.parse(response.data.obj.queryproperty);
          } else {
            this.query = dialog
          }

          if (response.data.obj.formproperty != 'null' || response.data.obj.formproperty != '') {
            this.formp = JSON.parse(response.data.obj.formproperty);
          } else {
            this.formp = [{name: ""}];
          }
        })
      },
      handlequery(index) {
        this.query.splice(index + 1, 0, {"name": ""})
      },
      handleformp(index) {
        this.formp.splice(index + 1, 0, {"name": ""})
      },
      handleEdit(index, row) {
        this.editeFlag = true;
      },
      deletequery(index, row) {
        if (this.query.length > 1) {
          this.query.splice(index, 1)
        } else {
          this.$message({
            message: '最后一行不能删除',
            type: 'warning'
          });
        }
      },
      deleteformp(index, row) {
        if (this.formp.length > 1) {
          this.formp.splice(index, 1)
        } else {
          this.$message({
            message: '最后一行不能删除',
            type: 'warning'
          });
        }
      },
      initAdd(setofbooks) {
        this.initForm();
        if (setofbooks)
          this.form.setofbooks = setofbooks;
        if (this.ifuseaccount == 1)
          this.form.openurl = this.defaultURL
        this.form.trademark = attUUID();
      },
      initForm() {
        this.formp = [{name: ""}];
        this.query = [{name: ""}];
        if (this.$refs.form1) {
          this.$refs.form1.resetFields();
        }
        this.form.setofbooks = "";
        this.form.trademark = "";
        this.form.productioncompany='';
        this.form.parentdserial = this.guid.categorycode;
        if (this.guid) {
          this.title = this.guid.categoryname;
        } else {
          this.title = "分类";
        }
        this.webshow=false;
        this.form.webshow=1;
        this.form.types=''
        if (this.$refs.refshangbiao) {
          this.$refs.refshangbiao.reset();
        }
        if (this.$refs.refguanggao) {
          this.$refs.refguanggao.reset();
        }
      },
      queryimport() {
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      querychange(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }

          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              //第一步先获取name
              for (let i in data) {
                var obj = {}
                var flage = true
                if (arr.length > 0) {
                  for (let j in arr) {
                    if (arr[j].name == data[i]['查询名称']) {
                      flage = false
                    }
                  }
                  if (flage) {
                    obj.name = data[i]['查询名称']
                    obj.edittype = data[i]['查询方式']
                    arr.push(obj)
                  }
                } else {
                  obj.name = data[i]['查询名称']
                  obj.edittype = data[i]['查询方式']
                  arr.push(obj)
                }
              }
              //第二步 拼接导入数据
              for (let i in arr) {
                var item = ''
                for (let j in data) {
                  if (arr[i].name == data[j]['查询名称']) {
                    if (item) {
                      item = item + ';' + data[j]['查询内容']
                    } else {
                      item = data[j]['查询内容']
                    }
                  }
                }
                arr[i].item = item
              }
              //第三步拼接的数据和query数据拼接到一起
              if (this.query.length > 0) {
                for (let i in arr) {
                  var flage = true
                  for (let j in this.query) {

                    if (this.query[j].name) {
                      if (this.query[j].name == arr[i].name) {
                        flage = false
                        this.query[j].item = this.query[j].item + ';' + arr[i].item
                      }
                    } else {
                      flage = false
                      this.query[j].name = arr[i].name
                      this.query[j].item = arr[i].item
                      this.query[j].edittype = arr[i].edittype
                    }
                  }
                  if (flage) {
                    this.query.push(arr[i])
                  }
                }
              } else {
                this.query = JSON.parse(JSON.stringify(arr))
              }
              //最后item去重
              for (let i in this.query) {
                var tempData = this.query[i].item.split(';');
                var hash = {};
                tempData = tempData.reduce(function (item, next) {
                  hash[next] ? '' : hash[next] = true && item.push(next);
                  return item;
                }, []);
                this.query[i].item = tempData.join(';')
              }
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      formpimport() {
        this.$refs.fileupload2.value = ''
        this.$refs.fileupload2.click()
      },
      formpchange(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              //第一步先获取name
              for (let i in data) {
                var obj = {}
                var flage = true
                if (arr.length > 0) {
                  for (let j in arr) {
                    if (arr[j].name == data[i]['属性名称']) {
                      flage = false
                    }
                  }
                  if (flage) {
                    obj.name = data[i]['属性名称']
                    obj.edittype = data[i]['属性方式']
                    obj.ispublic = data[i]['是否公有']
                    arr.push(obj)
                  }
                } else {
                  obj.name = data[i]['属性名称']
                  obj.edittype = data[i]['属性方式']
                  obj.ispublic = data[i]['是否公有']
                  arr.push(obj)
                }
              }
              //第二步 拼接导入数据
              for (let i in arr) {
                var item = ''
                for (let j in data) {
                  if (arr[i].name == data[j]['属性名称']) {
                    if (item) {
                      item = item + ';' + data[j]['属性内容']
                    } else {
                      item = data[j]['属性内容']
                    }
                  }
                }
                arr[i].item = item
              }
              //第三步拼接的数据和query数据拼接到一起
              if (this.formp.length > 0) {
                for (let i in arr) {
                  var flage = true
                  for (let j in this.formp) {
                    if (this.formp[j].name) {
                      if (this.formp[j].name == arr[i].name) {
                        flage = false
                        this.formp[j].item = this.formp[j].item + ';' + arr[i].item
                      }
                    } else {
                      flage = false
                      this.formp[j].name = arr[i].name
                      this.formp[j].item = arr[i].item
                      this.formp[j].edittype = arr[i].edittype
                      this.formp[j].ispublic = arr[i].ispublic
                    }
                  }
                  if (flage) {
                    this.formp.push(arr[i])
                  }
                }
              } else {
                this.formp = JSON.parse(JSON.stringify(arr))
              }
              //最后item去重
              for (let i in this.formp) {
                var tempData = this.formp[i].item.split(';');
                var hash = {};
                tempData = tempData.reduce(function (item, next) {
                  hash[next] ? '' : hash[next] = true && item.push(next);
                  return item;
                }, []);
                this.formp[i].item = tempData.join(';')
              }
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
    },
    mounted() {
      var param = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      if (param.setofbooks) {
        this.parames = JSON.parse(param.setofbooks);
      } else
        this.parames = [];

      var tokenTenantid = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
      for (let i in tokenTenantid.tenantDO) {
        if (tokenTenantid.tenantDO[i].unitguid == param.tenantid) {
          this.ifuseaccount = tokenTenantid.tenantDO[i].ifuseaccount;
        }
      }
    },
  }
</script>


<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {

  }

  .center {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/set/jxcgoodscategory/JxcgoodscategoryEdit.vue